import { useBridgeState } from '@digitaz/bridge-sdk-client';
import { AnalyticLogSourceEnum } from '../graphql/types';
import useScreenSize from './useScreenSize';

export const useAnalyticLogSource = (): AnalyticLogSourceEnum => {
  const { isWebView } = useBridgeState();
  const { isSmall } = useScreenSize();

  if (isWebView) return AnalyticLogSourceEnum.App;

  if (isSmall) return AnalyticLogSourceEnum.Mobile;

  return AnalyticLogSourceEnum.Desktop;
};
